/**
 * Canonical on-disk layout for config-as-code in a user's repo.
 *
 * Config lives under a product-namespaced root at the repo's git root:
 *
 *   wayai-ws/
 *     org/                 # org-as-code (shared resources)
 *     hubs/<hub>/          # one folder per preview hub
 *     bases/<base>/        # one folder per preview base
 *
 * This is the single source of truth for the directory NAMES, shared between
 * the backend `download_workspace` endpoint and the CLI. The CLI imports this
 * directly and bundles it at build time (tsup `noExternal` inlines `@wayai/core`
 * into the shipped binary), spreading it into `apps/cli/src/lib/layout.ts`
 * `WAYAI_LAYOUT` alongside its legacy fallback.
 *
 * One descriptor, three subtrees — NOT one descriptor per product. `pull`/`push`
 * are single verbs that route by subtree and refuse an invocation spanning both
 * `hubs/` and `bases/`.
 */
export const WAYAI_WORKSPACE_LAYOUT = {
  /** Product-namespaced root dir at the git root. */
  wsDir: 'wayai-ws',
  /** Subdir of `wsDir` holding hub folders. */
  hubsSubdir: 'hubs',
  /** Subdir of `wsDir` holding org-as-code. */
  orgSubdir: 'org',
  /** Subdir of `wsDir` holding base folders. */
  basesSubdir: 'bases',
} as const;

export type WorkspaceLayoutNames = typeof WAYAI_WORKSPACE_LAYOUT;
